export default __webpack_public_path__ + "static/media/cross-icon.ce144f9f.svg";